<div class="modal-header pt-3 px-3 bg-transparent">
  <!-- Back button - only show when looking at specific feature -->
  <div>
    @if (selectedIndex !== undefined) {
      <a 
        id="back"
        class="row mx-0 align-items-center" 
        style="text-decoration: none; color:inherit;" 
        tabindex="0" 
        [attr.aria-label]="'back'"
        [trackLink]="'back'"
        trackType="o"
        [prop15]="'back'"
        [prop10]="trackingString('arrow', ['plan details','back'])"
        [evar33]="trackingString('arrow', ['plan details','back'])"
        (click)="selectBackButton()"
        (keyup.enter)="selectBackButton()">
        <span class="icon-ui-arrowleft"></span>
        <p class="gb-label heavy my-0">{{'online_cancellation_back_copy' | translate}}</p>
      </a>
    }
  </div>
  <!-- Close button -->
  <div id="close" class="dismiss justify-content-end" (click)=" bsModalRef.hide()" (keyup.enter)="bsModalRef.hide()" aria-label="Close">
    <a style="text-decoration: none" tabindex="0">
      <span aria-hidden="true" class="icon-ui-close"></span>
    </a>
  </div>
</div>

@if (!isLoading) {
  <div class="modal-body px-0 pb-8 pb-md-10 bg-white">
    <!-- Modal title and subtitle -->
    <div class="gb-align-center px-12 mb-3 mb-md-6">
      <p class="gb-headline2 heavy mb-1">{{planName}}</p>
      @if (billingCadence) {
        <p class="gb-label heavy m-0">{{billingCadence}}</p>
      }
    </div>
    @if (selectedIndex !== undefined && features) {
      <!-- Viewing a specific feature -->
      <div>
        <div class="position-relative">
          <div class="px-md-12">
            <webu-about-plan-feature [featureCopy]="features[selectedIndex]" [featureImageAsset]="getFeatureAsset(features[selectedIndex].code)"></webu-about-plan-feature>
            <!-- Side buttons -->
            @if (selectedIndex > 0) {
              <a 
                class="position-absolute align-content-center side-nav-button left-nav" 
                tabindex="0"
                [attr.aria-label]="'arrow prev'"
                [trackLink]="'arrow prev'"
                trackType="o"
                [prop15]="'arrow prev'"
                [prop10]="trackingString('arrow', ['plan details','arrow prev'])"
                [evar33]="trackingString('arrow', ['plan details','arrow prev'])"
                (click)="selectFeature(selectedIndex - 1)"
                (keyup.enter)="selectFeature(selectedIndex - 1)">
                <span class="icon-ui-arrowleft text-light"></span>
              </a>
            }
            @if (selectedIndex < features.length - 1) {
              <a 
                class="position-absolute align-content-center side-nav-button right-nav" 
                tabindex="0"
                [attr.aria-label]="'arrow next'"
                [trackLink]="'arrow next'"
                trackType="o"
                [prop15]="'arrow next'"
                [prop10]="trackingString('arrow', ['plan details','arrow next'])"
                [evar33]="trackingString('arrow', ['plan details','arrow next'])"
                (click)="selectFeature(selectedIndex + 1)"
                (keyup.enter)="selectFeature(selectedIndex + 1)">
                <span class="icon-ui-arrowright text-light"></span>
              </a>
            }
          </div>
        </div>
        <!-- Nav circles on bottom -->
        <div class="row justify-content-center mt-10 col nav-circles">
          @for (featureInfo of features; track featureInfo.code; let i = $index) {
            <a 
              id="nav-circle"
              style="text-decoration: none; font-size: x-small;" 
              [ngStyle]="{color: selectedIndex === i ? '#787878' : '#D2D2D2'}" 
              tabindex="0" 
              class="mx-1" 
              [attr.aria-label]="'dots'"
              [trackLink]="'dots'"
              trackType="o"
              [prop15]="'dots'"
              [prop10]="trackingString('scroller', ['plan details','dots'])"
              [evar33]="trackingString('scroller', ['plan details','dots'])"
              (click)="selectFeature(i)"
              (keyup.enter)="selectFeature(i)">
              <span aria-hidden="true" class="icon-ui-circle"></span>
            </a>
          }
        </div>
      </div>
    }
    @else if (selectedIndex === undefined) {
      <!-- Modal "homepage" to view all features -->
      <div id="home" class="px-md-12">
        <div class="row">
          @if (planImageAsset) {
            <div class="col-md mb-6 mb-md-0">
              <img class="img-fluid plan-image" [src]="planImageAsset.urlPath" [attr.aria-label]="planImageAsset.imageAltText">
            </div>
          }
          <div class="col-md mx-5 mx-md-0">
            @for (featureInfo of features; track featureInfo.code; let last = $last; let i = $index) {
              <div>
                <a 
                  id="feature"
                  style="text-decoration: none; color:inherit;" 
                  tabindex="0"
                  [attr.aria-label]="featureInfo.name ?? 'unknown'"
                  [trackLink]="featureInfo.name ?? 'unknown'"
                  trackType="o"
                  [prop15]="featureInfo.name ?? 'unknown'"
                  [prop10]="trackingString('link', ['feature modal', featureInfo.name ?? 'unknown'])"
                  [evar33]="trackingString('link', ['feature modal', featureInfo.name ?? 'unknown'])"
                  (click)="selectFeature(i)"
                  (keyup.enter)="selectFeature(i)" 
                  class="row align-items-center mx-0">
                  <p class="col gb-body2 p-0 my-0">{{featureInfo.name}}</p>
                  <span aria-hidden="true" class="icon-ui-arrowright"></span>
                </a>
                @if (!last) {
                  <hr class="my-3">
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
@else { 
  <ox-loading></ox-loading>
}